import { render, staticRenderFns } from "./RoughDiagAnswer.vue?vue&type=template&id=0aa93115&scoped=true&"
import script from "./RoughDiagAnswer.vue?vue&type=script&lang=js&"
export * from "./RoughDiagAnswer.vue?vue&type=script&lang=js&"
import style0 from "./RoughDiagAnswer.vue?vue&type=style&index=0&id=0aa93115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa93115",
  null
  
)

export default component.exports